import { render, staticRenderFns } from "./vmiTransferDetail.vue?vue&type=template&id=014a6f7f&scoped=true&"
import script from "./vmiTransferDetail.js?vue&type=script&lang=js&"
export * from "./vmiTransferDetail.js?vue&type=script&lang=js&"
import style0 from "./vmiTransferDetail.scss?vue&type=style&index=0&id=014a6f7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014a6f7f",
  null
  
)

export default component.exports